module.exports = __webpack_public_path__ + "static/media/1.bdff0111.JPG";